import { render, staticRenderFns } from "./changeLevelNumStatistics.vue?vue&type=template&id=519694df&scoped=true&"
import script from "./changeLevelNumStatistics.vue?vue&type=script&lang=js&"
export * from "./changeLevelNumStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519694df",
  null
  
)

export default component.exports